import { AttributeValidationHandler } from '../ui-element.type';
import type { UIRemark } from './ui-remark';
import { isBrandColor } from '../../global/helpers-marketing';

/** @type {AttributeValidationHandler} */
export const validateRemarkColor: AttributeValidationHandler<UIRemark> = (
    component: UIRemark,
    value: string
) => {
    const info = `Allowed options are: turquoise, lilac, pineapple, orange.`;
    if (['yellow', 'blue'].includes(value)) {
        console.warn(`${value} - color is deprecated. ${info}`, component);
        return;
    }
    if (!isBrandColor(value)) {
        console.warn(`${value} - value does not exist. ${info}`, component);
    }
};
